
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Paper,
  Avatar
} from '@mui/material';
import { useTenant } from '../../contexts/tenant-context';

interface TenantSelectorProps {
  open: boolean;
  onSelect: (tenantId: string) => void;
  canClose?: boolean;
}

export const TenantSelector: React.FC<TenantSelectorProps> = ({
  open,
  onSelect,
  canClose = false,
}) => {
  const { availableTenants } = useTenant();

  const handleSelect = (tenantId: string) => {
    onSelect(tenantId);
  };

  return (
    <Dialog
      open={open}
      onClose={canClose ? undefined : () => {}}
      disableEscapeKeyDown={!canClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#000',
          color: '#fff',
          border: '2px solid hsl(19 101% 51% / 1)',
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid #fff', pb: 2 }}>
        <Typography variant="h5" fontWeight={600}>
          Select Tenant
        </Typography>

        <Typography
          variant="body2"
          sx={{ mt: 1, color: 'rgba(255,255,255,0.7)' }}
        >
          Please select a tenant to continue
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 4, pb: 3 }}>
        {availableTenants.length === 0 ? (
          <Box sx={{ py: 4, textAlign: 'center' }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.7)' }}>
              No tenants available. Please contact your administrator.
            </Typography>
          </Box>
        ) : (
          <List sx={{ pt: 1 }}>
            {availableTenants.map((tenant) => (
              <Paper
                key={tenant.tenantId}
                elevation={0}
                sx={{
                  mb: 2,
                  overflow: 'hidden',
                  bgcolor: 'transparent',
                  border: '1px solid #fff',
                  borderRadius: 1,
                }}
              >
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleSelect(tenant.tenantId)}
                    sx={{
                      py: 2,
                      px: 2.5,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      '&:hover': {
                        bgcolor: 'hsl(19 101% 51% / 1)',
                      },
                    }}
                  >
                   <Avatar
  variant="square"
  sx={{
    width: 70,
    height: 36,
    borderRadius: 1,
    bgcolor: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 0.5,
  }}
>
  {tenant.logoUrl ? (
    <Box
      component="img"
      src={tenant.logoUrl}
      alt={tenant.tenantName}
      sx={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
      }}
    />
  ) : (
    tenant.tenantName?.charAt(0)
  )}
</Avatar>
                    <ListItemText
                      primary={tenant.tenantName}
                      secondary={`Role: ${tenant.role}`}
                      primaryTypographyProps={{
                        fontWeight: 600,
                        fontSize: '1.1rem',
                        color: '#fff',
                      }}
                      secondaryTypographyProps={{
                        color: 'rgba(255,255,255,0.7)',
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </Paper>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

